// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, browserSessionPersistence, setPersistence } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Determine the appropriate authDomain based on environment
const getAuthDomain = () => {
  return 'us-medical-exams.firebaseapp.com'; // Use Firebase default for localhost
};

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDunh5Pzx4XY9PMdJ6WfXwCBS9hIqqvS5o",
  authDomain: getAuthDomain(),
  databaseURL: "https://us-medical-exams-default-rtdb.firebaseio.com",
  projectId: "us-medical-exams",
  storageBucket: "us-medical-exams.firebasestorage.app",
  messagingSenderId: "236706819053",
  appId: "1:236706819053:web:0c30516357abd07e0355e4",
  measurementId: "G-CMV9SGVXKN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Auth
export const auth = getAuth(app);

// Set session persistence (important for cross-domain)
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log("Auth persistence set to SESSION");
  })
  .catch((error) => {
    console.error("Error setting auth persistence:", error);
  });

// If in development, log information about the environment
if (process.env.NODE_ENV === 'development') {
  console.log("Running in development mode:", {
    hostname: window.location.hostname,
    authDomain: firebaseConfig.authDomain
  });
}